import { User2FAPhoneNumberModel } from '../../../../../../shared/models/UserModels';
import { PhoneNumberResources } from '../../../../../../Hub/TrainingHub/EnrollmentCard/ProductModal/ProfileUpdateModal/models';
import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUser2FANumber: builder.mutation<
      void,
      {
        accountId: string;
        accountUserId: string;
        phoneNumberRequest: User2FAPhoneNumberModel;
      }
    >({
      query: ({ accountId, accountUserId, phoneNumberRequest }) => ({
        url: `/v4/accounts/${accountId}/users/${accountUserId}/2fa-phoneNumber`,
        method: 'PUT',
        body: { ...phoneNumberRequest },
      }),
      invalidatesTags: ['User'],
    }),
    getPhoneNumberFieldSchema: builder.query<PhoneNumberResources, void>({
      query: () => `profile/phonenumbers/form`,
    }),
  }),
});

export const {
  useUpdateUser2FANumberMutation,
  useGetPhoneNumberFieldSchemaQuery,
} = apiSlice;
